import jwtDecode from 'jwt-decode';
import { userRoles } from '../shared/enums/dropdownEnums';
import { site } from '../shared/enums/site';

export interface JWT {
    nbf: number;
    exp: number;
    iat: number;
    // keys sent through JSON - strings double wrapped ("\"name\""), numbers single wrapped ("2")
    Email: string;
    FirstName: string;
    LastName: string;
    // number in string
    ID: string;
    // array in string ("[1, 2, 3]")
    Roles: string;
    // site enum in string
    Site: string;
}

export interface JWTData {
    email: string;
    firstName: string;
    lastName: string;
    id: number;
    roles: userRoles[];
    site: site;
}

export function validateJWT(token: string): boolean {
    try {
        if (!token) return false;
        return true;
    } catch {
        return false;
    }
}

export const getJwtToken = (): string | null => {
    return typeof window !== 'undefined' ? localStorage.getItem('token') : null;
};

export const clearJwtToken = (): void => {
    if (typeof window !== 'undefined') {
        localStorage.removeItem('token');
    }
};

export const formatJWT = (decoded: JWT): JWTData => {
    const { Email, FirstName, LastName, ID, Roles, Site } = decoded;
    if (!Roles) return {} as JWTData;
    const roles = Roles.replace(/[\[\]"]+/g, '')
        .split(',')
        .map(role => +role as userRoles);
    const siteEnum = parseInt(Site) as site;
    return {
        email: Email,
        firstName: FirstName,
        lastName: LastName,
        id: +ID,
        roles,
        site: siteEnum,
    };
};

export const getDecodedJwtToken = (): JWTData | null => {
    const token = getJwtToken();
    if (token === null) return null;
    const isValid = validateJWT(token);
    if (!isValid) {
        clearJwtToken();
        return null;
    }

    const decoded = jwtDecode<JWT>(token);
    const formatted = formatJWT(decoded);
    return formatted;
};
